/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { applyShellVhCssVariable } from './app/shell-viewport';
import { environment } from './environments/environment';

import { registerLocaleData } from '@angular/common';
// import localeHe from '@angular/common/locales/he';

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));

// registerLocaleData(localeHe);

// --- trying to fixing the language issue - NOT NEEDED! ---
import localeHe from '@angular/common/locales/he';
import localeEn from '@angular/common/locales/en';
import localeAr from '@angular/common/locales/ar';

// Bootstrap-time --vh: matches AppComponent logic with no translate banner yet (placeholder updated after load).
applyShellVhCssVariable(document, window, 0);

if (environment.production) {
  import('@sentry/angular').then((Sentry) => {
    Sentry.init({
      dsn: "https://a4e83bfefcc587f739aff681a56a5628@o4504164014555136.ingest.us.sentry.io/4508732359114752",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: 1.0,
      tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err =>
    console.error(err)
  );

if (localStorage.getItem('language') === 'en') {
  registerLocaleData(localeEn);
} else if (localStorage.getItem('language') === 'ar') {
  registerLocaleData(localeAr);
} else {
  registerLocaleData(localeHe);
}


// TAB CLICK
let currentTabIndex = 0;
let currentTotalTab = 0;

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Tab') return;

  const tabbables = getTabElements();
  if (!tabbables.length) return;

  const active = document.activeElement;
  let idx = tabbables.findIndex(el => el === active);

  if (idx !== -1) {
    currentTabIndex = idx + (e.shiftKey ? -1 : 1);
  } else {
    currentTabIndex = 0;
  }

  // דאג שהאינדקס לא יחרוג מהגבולות
  if (currentTabIndex >= tabbables.length) currentTabIndex = 0;
  if (currentTabIndex < 0) currentTabIndex = tabbables.length - 1;

  let tried = 0;
  let found = false;

  function tryFocusNext() {
    if (tried >= tabbables.length) return; // לא מצאנו שום אלמנט מתאים
    tabbables[currentTabIndex].focus();
    setTimeout(() => {
      if (document.activeElement === tabbables[currentTabIndex]) {
        found = true;
      } else {
        // דלג לאלמנט הבא
        currentTabIndex = (currentTabIndex + 1) % tabbables.length;
        tried++;
        tryFocusNext();
      }
    }, 0);
  }

  tryFocusNext();

  e.preventDefault();
});

function getTabElements(): HTMLElement[] {

  const dialogContainer = document.querySelector('mat-dialog-container');
  let nodeList = document.querySelectorAll('button, a, input, select, textarea, .my-tab-focus')
  if (dialogContainer) {
    nodeList = dialogContainer.querySelectorAll('button, a, input, select, textarea, .my-tab-focus');
  }
  const all = Array.from(nodeList).filter(
    (el, idx, arr) => arr.indexOf(el) === idx
  ).filter(
    (el): el is HTMLElement =>
      el instanceof HTMLElement &&
      !el.hasAttribute('disabled') &&
      el.tabIndex !== -1 &&
      (el.offsetWidth > 0 || el.offsetHeight > 0)
  );
  return all;
}
